import { CSS, h, View } from 'core';

export default (view: View, styles?: CSS) => {
  return h('div.content-view', { style: styles }, [h('div.content-view__main-panel', [view])]);
};
